import { Chapter, FadeUp } from "../Reveal";

const IMG_CONCRETE =
  "https://images.unsplash.com/photo-1601883683106-42e49ae6eda0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwyfHxhcmNoaXRlY3R1cmFsJTIwY29uY3JldGUlMjBzdG9uZSUyMHRpbWJlciUyMGZhY2FkZSUyMG1hdGVyaWFsc3xlbnwwfHx8fDE3ODk3MTczMDl8MA&ixlib=rb-4.1.0&q=85";
const IMG_WOOD =
  "https://images.pexels.com/photos/17094647/pexels-photo-17094647.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
const IMG_STONE_WOOD =
  "https://images.unsplash.com/photo-1768320837734-02390d59dfea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmFsJTIwYnVpbGRpbmclMjB3b29kJTIwc3RvbmUlMjBkZXRhaWx8ZW58MHx8fHwxNzg5NzE3MzA5fDA&ixlib=rb-4.1.0&q=85";
const IMG_ARCHES =
  "https://images.pexels.com/photos/35189812/pexels-photo-35189812.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const CATALOGUES = [
  {
    num: "02",
    id: "gros-oeuvre",
    title: "Gros œuvre & Structure",
    image: IMG_CONCRETE,
    alt: "Détail de béton architectural",
    families: [
      {
        name: "Maçonnerie & structure",
        items: ["Ciments, chaux et liants", "Mortiers, colles et enduits", "Blocs béton et briques", "Aciers, treillis et armatures", "Coffrage et accessoires", "Planchers et éléments structurels"],
      },
      {
        name: "TP, réseaux & drainage",
        items: ["Caniveaux et regards", "Tubes et évacuations", "Assainissement", "Drainage et géotextiles", "Réseaux secs", "Produits de voirie et aménagement"],
      },
      {
        name: "Façades & étanchéité",
        items: ["Enduits de façade", "Systèmes d'étanchéité", "Imperméabilisation", "Accessoires de mise en œuvre", "Produits de réparation"],
      },
      {
        name: "Chantier & consommables",
        items: ["Mastics et mousses", "Fixations et scellements", "Adhésifs et rubans", "Protection chantier", "Consommables de pose"],
      },
    ],
  },
  {
    num: "03",
    id: "isolation-bois-toiture",
    title: "Isolation, Bois & Toiture",
    image: IMG_WOOD,
    alt: "Façade bois contemporaine et jeux d'ombre",
    families: [
      {
        name: "Isolation & cloison",
        items: ["Laine minérale", "Isolants rigides", "Isolants biosourcés", "Plaques de plâtre", "Ossatures et accessoires", "Membranes et étanchéité à l'air"],
      },
      {
        name: "Bois & panneaux",
        items: ["Bois de structure", "Bois de charpente", "OSB", "Contreplaqués", "Panneaux techniques", "Bois d'aménagement"],
      },
      {
        name: "Couverture",
        items: ["Tuiles", "Ardoises", "Couverture métallique", "Zinguerie", "Écrans sous-toiture"],
      },
      {
        name: "Bardage & façade",
        items: ["Bardages", "Pare-pluie", "Lames et profils", "Systèmes de fixation", "Accessoires de finition"],
      },
    ],
  },
  {
    num: "04",
    id: "second-oeuvre",
    title: "Second œuvre & Aménagement",
    image: IMG_STONE_WOOD,
    alt: "Composition architecturale pierre et bois",
    families: [
      {
        name: "Menuiserie",
        items: ["Fenêtres et châssis", "Portes et blocs-portes", "Volets et fermetures", "Menuiseries intérieures", "Accessoires de pose"],
      },
      {
        name: "Sols & murs",
        items: ["Carrelage", "Faïence", "Revêtements de sol", "Parquet et stratifié", "Colles et joints", "Profilés et finitions"],
      },
      {
        name: "Sanitaire & plomberie",
        items: ["Appareils sanitaires", "Robinetterie", "Évacuation", "Alimentation", "Raccords et accessoires"],
      },
      {
        name: "Électricité & confort",
        items: ["Appareillage électrique", "Éclairage", "Chauffage", "Traitement de l'air", "Accessoires techniques"],
      },
    ],
  },
  {
    num: "05",
    id: "exterieurs-outillage",
    title: "Extérieurs, Outillage & Équipements",
    image: IMG_ARCHES,
    alt: "Arches en pierre, détail architectural",
    families: [
      {
        name: "Aménagement extérieur",
        items: ["Terrasses", "Clôtures et portails", "Pavés et dalles", "Bordures", "Drainage", "Produits paysagers"],
      },
      {
        name: "Outillage professionnel",
        items: ["Outillage à main", "Électroportatif", "Découpe et perçage", "Mesure", "Manutention légère", "Accessoires"],
      },
      {
        name: "Quincaillerie",
        items: ["Visserie", "Chevilles", "Fixations", "Ferrures", "Serrurerie", "Consommables"],
      },
      {
        name: "Sécurité chantier",
        items: ["EPI", "Signalisation", "Protection des surfaces", "Balisage", "Accessoires de sécurité"],
      },
    ],
  },
];

const CatalogueChapter = ({ chapter, index }) => {
  const imageLeft = index % 2 === 1;
  return (
    <div id={chapter.id} data-testid={`catalogue-${chapter.id}`} className="scroll-mt-28">
      <Chapter num={chapter.num} label="Nos matériaux" />
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
        <FadeUp className={`lg:col-span-4 ${imageLeft ? "lg:order-2" : ""}`}>
          <h2 className="font-display font-medium text-petrol text-3xl sm:text-4xl leading-tight tracking-tight mb-8">
            {chapter.title}
          </h2>
          <div
            className={`overflow-hidden border border-petrol/10 shadow-lg shadow-petrol/5 ${
              imageLeft ? "rounded-[2.5rem] rounded-tr-[120px]" : "rounded-[2.5rem] rounded-tl-[120px]"
            }`}
          >
            <img
              src={chapter.image}
              alt={chapter.alt}
              loading="lazy"
              className="w-full h-64 lg:h-80 object-cover transition-transform duration-700 hover:scale-105"
            />
          </div>
        </FadeUp>
        <div className={`lg:col-span-8 ${imageLeft ? "lg:order-1" : ""}`}>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            {chapter.families.map((family, i) => (
              <FadeUp key={family.name} delay={i * 0.08}>
                <div
                  data-testid={`famille-${chapter.id}-${i}`}
                  className="h-full bg-white rounded-3xl border border-petrol/10 p-6 transition-all duration-300 hover:-translate-y-1 hover:border-teal/40 hover:shadow-lg hover:shadow-petrol/5"
                >
                  <h3 className="text-[15px] font-semibold text-petrol mb-4 flex items-center gap-3">
                    <span className="w-1.5 h-3 rounded-t-full bg-teal shrink-0" aria-hidden="true" />
                    {family.name}
                  </h3>
                  <ul className="space-y-0">
                    {family.items.map((item) => (
                      <li
                        key={item}
                        className="text-[13px] text-mute py-1.5 border-b border-petrol/5 last:border-0"
                      >
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </FadeUp>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export const Materiaux = () => (
  <section id="materiaux" data-testid="materiaux-section" className="bg-creme py-20 lg:py-32 scroll-mt-16">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
      <FadeUp className="mb-16 lg:mb-24 max-w-3xl">
        <p className="text-xs uppercase tracking-[0.28em] font-semibold text-teal mb-4">
          Le catalogue EQUORIS
        </p>
        <h2 className="font-display font-medium text-petrol text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight">
          Quatre univers de matériaux, une seule demande.
        </h2>
      </FadeUp>
      <div className="space-y-24 lg:space-y-32">
        {CATALOGUES.map((chapter, i) => (
          <CatalogueChapter key={chapter.id} chapter={chapter} index={i} />
        ))}
      </div>
      <FadeUp className="mt-20">
        <p
          data-testid="materiaux-mention"
          className="text-center text-sm text-pierre italic max-w-2xl mx-auto bg-sagelight/60 rounded-full px-6 py-4"
        >
          Liste indicative non exhaustive. Gammes, marques, dimensions et caractéristiques
          proposées selon le besoin et la disponibilité.
        </p>
      </FadeUp>
    </div>
  </section>
);
